import React from 'react';
import { MapPin, Cpu, Target } from 'lucide-react';
import { companyInfo } from '../../data/company';
import { Badge, Card } from '../ui';

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-12 sm:py-14 lg:py-16 relative overflow-hidden bg-white dark:bg-[#080e1a]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Left Column: Story & Mission */}
          <div className="lg:col-span-6 space-y-6">
            <Badge variant="brand" className="px-3.5 py-1 text-xs uppercase tracking-wider">
              About Technook Global
            </Badge>

            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#184166] dark:text-white tracking-tight">
              A technology hub dedicated to creating <span className="bg-gradient-to-r from-[#4a82c2] via-[#08adae] to-sky-400 bg-clip-text text-transparent">innovative software</span> & smart business systems
            </h2>

            <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
              Technook is a full-service technology hub located at Imperial Plaza, Parañaque City. We empower organizations to grow in the digital age by engineering custom web applications, mobile platforms, visual brand assets, and automated B2B sales pipelines.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
              <Card variant="glass" className="p-4 space-y-2 bg-[#f5f9fc] dark:bg-[#0f1b2d]">
                <div className="flex items-center gap-2 text-[#4a82c2] font-bold text-sm">
                  <Target size={18} /> Mission Statement
                </div>
                <p className="text-xs text-slate-600 dark:text-slate-400">
                  To provide practical, high-value technical solutions that simplify operations and transform lives.
                </p>
              </Card>

              <Card variant="glass" className="p-4 space-y-2 bg-[#f5f9fc] dark:bg-[#0f1b2d]">
                <div className="flex items-center gap-2 text-[#08adae] font-bold text-sm">
                  <Cpu size={18} /> Global Vision
                </div>
                <p className="text-xs text-slate-600 dark:text-slate-400">
                  To be the preferred tech partner for growing businesses seeking maintainable, high-impact systems.
                </p>
              </Card>
            </div>
          </div>

          {/* Right Column: Office Location & Delivery Hub */}
          <div className="lg:col-span-6">
            <Card variant="glass" className="p-8 space-y-6 bg-[#f5f9fc] dark:bg-[#0f1b2d] border border-slate-200 dark:border-slate-800">
              <div className="flex items-center gap-3">
                <div className="p-3 rounded-2xl bg-[#4a82c2]/10 border border-[#4a82c2]/30 text-[#4a82c2]">
                  <MapPin size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#184166] dark:text-white">Technook Philippines HQ</h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400">Imperial Plaza, Diosdado Macapagal Blvd., Parañaque City</p>
                </div>
              </div>

              <div className="space-y-3 pt-2 text-xs text-slate-600 dark:text-slate-300 border-t border-slate-200 dark:border-slate-800">
                <div className="flex items-center justify-between py-1 border-b border-slate-200 dark:border-slate-800/60">
                  <span className="text-slate-500 dark:text-slate-400">Primary Email:</span>
                  <span className="font-mono text-[#4a82c2] font-semibold">{companyInfo.email}</span>
                </div>
                <div className="flex items-center justify-between py-1 border-b border-slate-200 dark:border-slate-800/60">
                  <span className="text-slate-500 dark:text-slate-400">Direct Contact:</span>
                  <span className="font-mono text-slate-700 dark:text-slate-200 font-semibold">{companyInfo.phones[0]}</span>
                </div>
                <div className="flex items-center justify-between py-1">
                  <span className="text-slate-500 dark:text-slate-400">Delivery Model:</span>
                  <span className="font-bold text-emerald-600 dark:text-emerald-400">Onsite Leadership & Agile Engineering</span>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};
